import _BaseAPIService from "../../../Services/_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "api";

const CRUDService = {
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/usernamagement/register`,
      data
    );
    return response.data;
  },

  getList: async (data) => {
    const response = await apiService.get(
      `/${slug}/usernamagement?trackEntity=${data.trackEntity}&page=${data.page}&pageSize=${data.pageSize}`
    );
    return response.data;
  },

  getRoles: async () => {
    const response = await apiService.get(`/${slug}/auth/roles`);
    return response.data;
  },
  update: async (userId, data) => {
    const response = await apiService.put(
      `/${slug}/usernamagement/${userId}`,
      data
    );
    return response.data;
  },
  delete: async (userId) => {
    const response = await apiService.delete(
      `/${slug}/usernamagement/${userId}`
    );
    return response.data;
  },
  getUserDetail: async (userId) => {
    const response = await apiService.get(`/${slug}/usernamagement/${userId}`);
    return response.data;
  },
};

export default CRUDService;
